import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ProductTypeEnum } from '../ProductTypeEnum'

export enum BuildProductStatusEnum {
  Created = 'created',
  Failed = 'failed',
}

@InputType()
export class ProductDimensionsInput {
  @Field(() => Float)
  verticalIn: number

  @Field(() => Float)
  horizontalIn: number

  @Field(() => Float, { nullable: true })
  cornerRadiusIn?: number
}

@InputType()
export class ProductVendorEntryInput {
  @Field(() => ID)
  vendorId: string

  @Field(() => String)
  vendorCode: string

  @Field(() => Float)
  unitPrice: number
}

@InputType()
export class BuildProductRemarksInput {
  @Field(() => String)
  kind: string

  @Field(() => String)
  message: string
}

@InputType()
export class BuildProductFromDraftArgs extends ActionArgs {
  @Field(() => String)
  productType: ProductTypeEnum

  @Field(() => String)
  code: string

  @Field(() => String)
  name: string

  @Field(() => ID, { nullable: true })
  baseProductId?: string

  @Field(() => ProductDimensionsInput, { nullable: true })
  dimensions?: ProductDimensionsInput

  @Field(() => [ProductVendorEntryInput], { nullable: true })
  vendors?: ProductVendorEntryInput[]

  @Field(() => Float, { nullable: true })
  price?: number

  @Field(() => [String], { nullable: true })
  tags?: string[]

  @Field(() => BuildProductRemarksInput, { nullable: true })
  remarksActivity?: BuildProductRemarksInput
}

@ObjectType()
export class BuildProductResult {
  @Field(() => ID)
  _id: string

  @Field(() => String)
  code: string

  @Field(() => String)
  status: BuildProductStatusEnum

  @Field(() => String, { nullable: true })
  error?: string
}

export interface IBuildProductFromDraft extends IAction<BuildProductResult, BuildProductFromDraftArgs> {}
